export function getCache<T>(key: string, fallback: T): T {
  try {
    const saved = sessionStorage.getItem(key);
    return saved ? JSON.parse(saved) : fallback;
  } catch {
    return fallback;
  }
}

export function setCache<T>(key: string, value: T) {
  sessionStorage.setItem(key, JSON.stringify(value));
}